// extracted by mini-css-extract-plugin
export default {"yearPage":"year-page_yearPage__7LYBk"};